import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as reserveTimesActions from '../../../redux/reserveTimes/actions';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import ReserveHoursListTable from './ListTable';
import CafeTimesFilters from './Filters';
import submitForm from '../../../utils/submitForm';

class ReservationHours extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      sortType: 'asc',
    };
  }
  componentDidMount() {
    const query = this.buildSearchQuery(
      this.state.currentPage,
      this.state.itemsPerPage,
    );
  }

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllReservationHours(
        searchQuery,
        this.props.match.params.reservationDayId,
      );
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllReservationHours(
        query,
        this.props.match.params.reservationDayId,
      );
    });
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  getAllReservationHours = () => {
    this.setState({ query: ''});
    const newQuery = `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`;
    ;
    this.props.actions.fetchAllReservationHours(
      newQuery,
      this.props.match.params.reservationDayId,
    );
  };
  
  render() {
    const { loading, message, failed, error } = this.props;
    const { totalRecords } = this.props.reservationHours;
    const { currentPage, itemsPerPage } = this.state;

    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <div className='col-12 d-flex justify-content-between align-items-center'>
          <h3 className='text-right text-muted py-4'>
            <div className='text-right'>
              {locales('titles.reservationHours')}
            </div>
          </h3>
          <div>
            {/* <NavLink
              to={{
                pathname: '/reservation/hours/new',
                editMode: false,
                reservationDayDate: this.props.location.reservationDayDate,
                reservationDayId: this.props.location.reservationDayId
              }}
            >
              <button className="btn btn-primary w-5 mx-1">
                <i className="fal fa-plus mx-1" />
                {locales('titles.newHour')}
              </button>
            </NavLink> */}
            <button
              onClick={() =>
                this.props.history.push('/reservation-days-management')
              }
              className='btn btn-default w-5 mx-1'
            >
              <i className='fa fa-reply' />
              {locales('labels.return')}
            </button>
          </div>
        </div>

        <CafeTimesFilters
          applyFilters={this.applyFilters}
          getAllReservationHours={this.getAllReservationHours}
        />

        <section className='p-1 col-12'>
          <Spin spinning={loading}>
            <article>
              <main className='panel panel-default'>
                {error ? (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                ) : (
                  <>
                    {failed && (
                      <div className='alert alert-danger'>{message}</div>
                    )}
                    <div className='panel-heading'>
                      <i className='fas fa-list-alt px-1' />
                      {locales('titles.reservationHoursList')}
                    </div>
                    <div className='panel-body'>
                      <React.Fragment>
                        <ReserveHoursListTable
                          pageNumber={currentPage}
                          reservationDayDate={
                            this.props.location.reservationDayDate
                          }
                          reservationDayId={
                            this.props.match.params.reservationDayId
                          }
                          pageSize={itemsPerPage}
                        />
                        <footer className='col-12 d-flex justify-content-center py-2'>
                          <div className='pagination-container'>
                            <Pagination2
                              totalRecords={totalRecords || 0}
                              pageLimit={itemsPerPage}
                              pageNeighbours={2}
                              onPageChanged={this.onPageChanged}
                              currentPage={this.state.currentPage}
                            />
                          </div>
                        </footer>
                      </React.Fragment>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationHoursList: state.reserveTimesReducer.reservationHoursList,
    reservationHours: state.reserveTimesReducer.reservationHours,
    loading: state.reserveTimesReducer.reservationHoursLoading,
    message: state.reserveTimesReducer.reservationHoursMessage,
    failed: state.reserveTimesReducer.reservationHoursFailed,
    error: state.reserveTimesReducer.reservationHoursError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllReservationHours: (query, cafeDateId) =>
        dispatch(
          reserveTimesActions.fetchAllReservationHours(query, cafeDateId),
        ),
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReservationHours),
);
